export default {
  en: {
    newRoomType: 'New Room Type',
    roomTypeList: 'Room Type',
    code: 'Code',
    name: 'Name',
    status: 'Status',
    create: 'Create Room Type',
    cancel: 'Cancel',
    createRoomTypeSuccessTitle: 'Success',
    createRoomTypeSuccessMessage: 'Create Room Type Success.'
  },
  th: {
    newRoomType: 'สร้างประเภทห้อง',
    roomTypeList: 'รายการประเภทห้อง',
    code: 'โค้ด',
    name: 'ชื่อ',
    status: 'สถานะ',
    create: 'สร้างประเภทห้อง',
    cancel: 'ยกเลิก',
    createRoomTypeSuccessTitle: 'สำเร็จ',
    createRoomTypeSuccessMessage: 'สร้างประเภทห้องสำเร็จ'
  }
}
